// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper_1hHaS","img":"img_1R4Od"};